import { Pipe, PipeTransform } from '@angular/core';
import { CaseTypeLite } from '../../domain/definition/case-type-lite.model';

@Pipe({
  name: 'sortCaseTypes'
})
export class SortCaseTypesPipe implements PipeTransform {

  transform(caseTypes: CaseTypeLite[]): CaseTypeLite[] {
    if (!caseTypes) {
      return [];
    }
    return [...caseTypes].sort(this.compareName);
  }

  private compareName(a: CaseTypeLite, b: CaseTypeLite): number {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();

    if (nameA < nameB) {
      return -1;
    } else if (nameA > nameB) {
      return 1;
    }

    // Equal
    return 0;
  }
}
